import React from 'react';

const SessionContext = React.createContext({});

  export { SessionContext };
  export default SessionContext;
